import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  /** Matches the rows it sits next to: `sm` on cards, `md` in overlays. */
  size?: 'sm' | 'md'
}

export const RoomlessDisclaimer = ({size = 'sm'}: Props) => (
  <Box
    display="flex"
    alignItems="flex-start"
    gap={size === 'md' ? 's300' : 's250'}
    data-id="roomlessDisclaimer"
  >
    {/* The copy wraps on narrow screens, so keep the icon on the first line */}
    <Box
      display="flex"
      alignItems="center"
      paddingTop="s100"
      paddingBottom="s100"
    >
      <Icon name="Information" size={size} />
    </Box>
    <Text variant={size === 'md' ? 'bodyM' : 'bodyS'}>
      <FormattedMessageWrapper
        id="room.fullDetailsAfterBooking"
        defaultMessage="Full room details shown after booking"
      />
    </Text>
  </Box>
)
